module.exports = __webpack_public_path__ + "img/stock3.c8a099a3.png";